import styled from '@emotion/styled';
import { PropsWithChildren } from 'react';

function Toolbar({ children }: PropsWithChildren) {
  if (!children) {
    return null;
  }

  return <ToolbarContainer className="flex items-center">{children}</ToolbarContainer>;
}

const ToolbarContainer = styled.div`
  view-transition-name: toolbar;

  background: rgba(31, 31, 33, 0.92);
  color: white;
  padding: 0.25rem 0.5rem;
  margin: 0;

  position: fixed;
  top: 0.75rem;
  right: 0.75rem;
  z-index: 10000;

  display: flex;
  gap: 0.5rem;

  border-radius: 8px;
  border-bottom: 2px solid var(--walky-orange);
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(12px);

  svg {
    fill: white;
    width: 2.25rem;
    height: 2.25rem;
    transition: transform 200ms;

    &:hover {
      transform: scale(1.12);
    }
  }

  @media (max-width: 480px) {
    top: 0.5rem;
    right: 0.5rem;

    svg {
      width: 2rem;
      height: 2rem;
    }
  }
`;

export default Toolbar;
